import { useEffect, useState } from "react";
import { Zap, Radiation } from "lucide-react";

// NukeStatusHUD — small HUD panel showing both sides' nuclear-missile state.
// Polls nukeStateRef every 250ms.
export default function NukeStatusHUD({ nukeStateRef, isMobile }) {
  const [tick, setTick] = useState({
    bullReady: true, bullCooldown: 0, bullPhase: "idle",
    bearReady: true, bearCooldown: 0, bearPhase: "idle",
  });

  useEffect(() => {
    const id = setInterval(() => {
      const s = nukeStateRef?.current;
      if (!s) return;
      setTick((prev) => {
        if (prev.bullReady === s.bullReady
          && Math.round(prev.bullCooldown) === Math.round(s.bullCooldown)
          && prev.bullPhase === s.bullPhase
          && prev.bearReady === s.bearReady
          && Math.round(prev.bearCooldown) === Math.round(s.bearCooldown)
          && prev.bearPhase === s.bearPhase) return prev;
        return { ...s };
      });
    }, 250);
    return () => clearInterval(id);
  }, [nukeStateRef]);

  const labelFor = (phase, ready, cooldown) => {
    if (phase === "launching" || phase === "flight") return "LAUNCHING";
    if (!ready) return `READY IN ${Math.ceil(cooldown)}s`;
    return "READY";
  };
  const stateClass = (phase, ready) => {
    if (phase === "launching" || phase === "flight") return "text-[#FFE480] animate-pulse";
    if (!ready) return "text-[#FF2A2A]";
    return "text-[#00FFA3]";
  };

  const pos = isMobile
    ? "left-3 right-3 top-[calc(20vh+180px)]"
    : "left-1/2 -translate-x-1/2 top-[calc(18vh+20px)]";

  return (
    <div
      className={`absolute z-30 ${pos} pointer-events-none flex ${isMobile ? "gap-2" : "gap-3"}`}
      data-testid="nuke-status-hud"
    >
      <div
        className="cb-hud-chip !bg-black/60 backdrop-blur-md px-3 py-1.5 flex items-center gap-2 border-l-2 !border-l-[#3d5c2a] flex-1"
        data-testid="nuke-status-bull"
        data-phase={tick.bullPhase}
      >
        <Radiation className="w-3.5 h-3.5 text-[#3d5c2a]" />
        <span className="font-mono-tac text-[9px] uppercase tracking-[0.24em] text-slate-400">
          Bull Nuke
        </span>
        <span
          className={`font-mono-tac text-[10px] tabular-nums uppercase tracking-[0.16em] ${stateClass(tick.bullPhase, tick.bullReady)} ml-auto`}
          data-testid="nuke-status-bull-label"
        >
          {labelFor(tick.bullPhase, tick.bullReady, tick.bullCooldown)}
        </span>
      </div>
      <div
        className="cb-hud-chip !bg-black/60 backdrop-blur-md px-3 py-1.5 flex items-center gap-2 border-r-2 !border-r-[#7a2a2a] flex-1"
        data-testid="nuke-status-bear"
        data-phase={tick.bearPhase}
      >
        <span
          className={`font-mono-tac text-[10px] tabular-nums uppercase tracking-[0.16em] ${stateClass(tick.bearPhase, tick.bearReady)} mr-auto`}
          data-testid="nuke-status-bear-label"
        >
          {labelFor(tick.bearPhase, tick.bearReady, tick.bearCooldown)}
        </span>
        <span className="font-mono-tac text-[9px] uppercase tracking-[0.24em] text-slate-400">
          Bear Nuke
        </span>
        <Zap className="w-3.5 h-3.5 text-[#7a2a2a]" />
      </div>
    </div>
  );
}
